var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{style:({ maxWidth: ((5 * _vm.size) + "px"), maxHeight: ((2 * _vm.size) + "px"), minHeight: ((2 * _vm.size) + "px") }),attrs:{"position":"center left","contain":"","src":require("@/assets/logo-lpb-black-label.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }